<template>
  <div class="label-site-footer">
    <ul class="sns_accounts">
      <li>
        <a
          href="https://www.youtube.com/channel/UCCsQ0CIXzv_AT0L3RPGK4ZQ"
          target="_blank"
          rel="noopener"
          v-on:click="clickLink('gallery_youtube')"
        >
          <img
            :src="app_root +'/assets/common/img/logo/youtube_social_squircle_dark.png'"
          />
        </a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/epsongallery/"
          target="_blank"
          rel="noopener"
          v-on:click="clickLink('gallery_insta')"
        >
          <img
            :src="app_root + '/assets/common/img/logo/glyph-logo_May2016.png'"
          />
        </a>
      </li>
    </ul>

    <!-- 2023/6 Ver.3.1.0新設フッター -->
    <ul class="footer_link">
      <li>
        <SelectLangModal />
      </li>
      <li>
        <a
          v-bind:href="createPath()"
          v-on:click="clickLink('tou')"
        >
          <!-- サイトのご利用について -->
          <LabelFunMessage fcontId="0" msgkey="24" />

        </a>
      </li>
      <li>
        <a v-bind:href="sn_root + '/trademark/?LG2=' + lg2.toUpperCase()"
          v-on:click="clickLink('trademarks')">
          <LabelFunMessage fcontId="0" msgkey="183" />
        </a>
      </li>
      <li>
        <a v-bind:href="sn_root + '/privacy/?LG2=' + lg2.toUpperCase()"
          v-on:click="clickLink('privacy_statement')">
          <LabelFunMessage fcontId="0" msgkey="184" />
        </a>
      </li>
    </ul>

    <ul class="footer_copyright">
      <li>
        <div id="copyright">&copy; Seiko Epson Corporation {{ year }}</div>
      </li>
    </ul>

    <!-- 言語選択モーダル本体 ※sn5.1のコードをそのまま入れている。denyBackgroundScrollのJS必要。ギャラリーはJPorWWで表示する選択言語が異なるので出し分け必要。-->
    <div class="modal fade" id="languageModal" tabindex="-2">
      <div class="modal-dialog language-modal">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <p class="close_modal_button">×</p>
            </button>
            <h3 class="modal-title">
              <!-- 言語を選択してください -->
              <LabelFunMessage fcontId="0" msgkey="176" />
            </h3>
          </div>
          <div class="modal-body">
            <div class="scrolldown"><span>scroll</span></div>
            <ul class="LanguageList row">
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=AR&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'AR');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'AR' });"
                  >العربية</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=AZ&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'AZ');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'AZ' });"
                  >Azərbaycan</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=BY&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'BY');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'BY' });"
                  >Беларуская</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=BG&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'BG');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'BG' });"
                  >Български</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=CA&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'CA');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'CA' });"
                  >Català</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=ZH&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'ZH');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'ZH' });"
                  >繁體中文</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=C2&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'C2');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'C2' });"
                  >简体中文</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=HR&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'HR');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'HR' });"
                  >Hrvatski</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=CS&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'CS');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'CS' });"
                  >Česky</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=DA&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'DA');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'DA' });"
                  >Dansk</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=NL&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'NL');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'NL' });"
                  >Nederlands</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=EN&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'EN');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'EN' });"
                  >English</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=ET&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'ET');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'ET' });"
                  >Eesti</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=FA&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'FA');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'FA' });"
                  >فارسی</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=FI&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'FI');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'FI' });"
                  >Suomi</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=FR&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'FR');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'FR' });"
                  >Français</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=DE&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'DE');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'DE' });"
                  >Deutsch</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=EL&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'EL');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'EL' });"
                  >Ελληνικά</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=HE&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'HE');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'HE' });"
                  >עברית</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=HI&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'HI');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'HI' });"
                  >हिन्दी</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=HU&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'HU');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'HU' });"
                  >Magyar</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=ID&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'ID');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'ID' });"
                  >Bahasa Indonesia</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=IT&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'IT');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'IT' });"
                  >Italiano</a
                >
              </li>
              <li class="col-xs-12 col-sm-3 selected">
                <a
                  href="/setupnavi/?LG2=JA&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'JA');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'JA' });"
                  >日本語</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=KK&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'KK');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'KK' });"
                  >қазақша</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=KO&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'KO');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'KO' });"
                  >한국어</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=LV&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'LV');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'LV' });"
                  >Latviešu</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=LT&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'LT');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'LT' });"
                  >Lietuvių</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=MK&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'MK');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'MK' });"
                  >Македонски</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=MS&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'MS');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'MS' });"
                  >Bahasa Melayu</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=MN&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'MN');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'MN' });"
                  >Монгол</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=NN&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'NN');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'NN' });"
                  >Norsk</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=PL&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'PL');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'PL' });"
                  >Polski</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=PT&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'PT');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'PT' });"
                  >Portugues</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=RO&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'RO');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'RO' });"
                  >Română</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=RU&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'RU');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'RU' });"
                  >русскнй</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=SR&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'SR');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'SR' });"
                  >Српски</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=SK&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'SK');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'SK' });"
                  >Slovenčina</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=SL&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'SL');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'SL' });"
                  >Slovenščina</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=ES&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'ES');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'ES' });"
                  >Español</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=SW&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'SW');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'SW' });"
                  >Kiswahili</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=SV&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'SV');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'SV' });"
                  >Svenska</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=TH&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'TH');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'TH' });"
                  >Phasa Thai</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=TR&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'TR');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'TR' });"
                  >Türkçe</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=TK&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'TK');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'TK' });"
                  >Туркмен</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=UK&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'UK');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'UK' });"
                  >Українська</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=UZ&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'UZ');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'UZ' });"
                  >Ўзбек</a
                >
              </li>
              <li class="col-xs-12 col-sm-3">
                <a
                  href="/setupnavi/?LG2=VI&amp;OSC=WS&amp;PINF=menu&amp;MKN=&amp;GROUP="
                  onclick="ga('send', 'event', 'footer', 'language', 'VI');gtag('event', 'tap_button', { 'custom_parameter1' : 'footer', 'custom_parameter2' : 'language', 'custom_parameter3' : 'VI' });"
                  >Tiếng Việt</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- / 2023/6 Ver.3.1.0新設フッター -->

    <!-- <ul class="row text-center">
      <li class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <a v-bind:href="createPath()" target="_blank" v-on:click="clickLink('tou')">
          <LabelFunMessage fcontId="0" msgkey="24" />
        </a>
      </li>
      <li class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <a href="http://www.epson.com/" v-on:click="clickLink('EPSONCOM')">EPSON.COM</a>
      </li>
      <li class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <div id="copyright">&copy; Seiko Epson Corp. {{ year }}</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import SelectLangModal from "../components/SelectLangModal";
// import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "LabelSiteFooter",
  components: {
    SelectLangModal,LabelFunMessage,
    // LabelFunMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
      sn_root: process.env.VUE_APP_SETUPNAVI_ROOT
    };
  },
  computed: {
    ...mapState(["setupnavi", "lg2"]),
    year: function () {
      const date = new Date(document.lastModified);
      const year = date.getFullYear();

      return year;
    },
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    },
    articleNo: function () {
      let label = "other";
      const result = this.$route.path.match(/\/articles/);
      if (result != null) {
        label = this.fcontId;
      }
      return label;
    },
  },
  methods: {
    createPath: function () {
      return `${
        process.env.VUE_APP_SETUPNAVI_ROOT
      }/tou/${this.lg2.toUpperCase()}_terms.html`;
    },
    clickLink: function (action) {
      // GA4
      if (action == "gallery_youtube") {
        this.$gtag.event("go_sns", {
          sns_name: "youtube",
          location_id: "footer",
          article_no: this.articleNo,
        });
      } else if (action == "gallery_insta") {
        this.$gtag.event("go_sns", {
          sns_name: "instagram",
          location_id: "footer",
          article_no: this.articleNo,
        });
      } else if (action == "tou") {
        this.$gtag.event("tap_button", {
          custom_parameter1: "terms_of_use",
        });
      } else {
        this.$gtag.event("tap_button", {
          custom_parameter1: action,
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sns_accounts {
  text-align: center;
}

.sns_accounts li {
  display: inline-block;
  margin-right: 20px;
  width: 30px;
}
</style>
